/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/

import type { LazyModal } from '@freelancer/ui/modal';

export const uiModals: { [k: string]: LazyModal } = {
  CameraModal: {
    loadComponent: () =>
      import('@freelancer/ui/camera-modal/camera-modal.component').then(
        m => m.CameraModalComponent,
      ),
    loadModule: () =>
      import('@freelancer/ui/camera-modal/camera-modal.module').then(
        m => m.CameraModalModule,
      ),
  },
  FileViewerModal: {
    loadComponent: () =>
      import(
        '@freelancer/ui/file-viewer/file-viewer-modal/file-viewer-modal.component'
      ).then(m => m.FileViewerModalComponent),
    loadModule: () =>
      import(
        '@freelancer/ui/file-viewer/file-viewer-modal/file-viewer-modal.module'
      ).then(m => m.FileViewerModalModule),
  },
  PermissionsRecoveryModal: {
    loadComponent: () =>
      import(
        '@freelancer/ui/permissions/recovery-modal/permissions-recovery-modal.component'
      ).then(m => m.PermissionsRecoveryModalComponent),
    loadModule: () =>
      import(
        '@freelancer/ui/permissions/recovery-modal/permissions-recovery-modal.module'
      ).then(m => m.PermissionsRecoveryModalModule),
  },
  PermissionsRequestModal: {
    loadComponent: () =>
      import(
        '@freelancer/ui/permissions/request-modal/permissions-request-modal.component'
      ).then(m => m.PermissionsRequestModalComponent),
    loadModule: () =>
      import(
        '@freelancer/ui/permissions/request-modal/permissions-request-modal.module'
      ).then(m => m.PermissionsRequestModalModule),
  },
  ShareModal: {
    loadComponent: () =>
      import('@freelancer/ui/share-modal/share-modal.component').then(
        m => m.ShareModalComponent,
      ),
    loadModule: () =>
      import('@freelancer/ui/share-modal/share-modal.module').then(
        m => m.ShareModalModule,
      ),
  },
  UpdateNativeModal: {
    loadComponent: () =>
      import(
        '@freelancer/ui/update-native-alert/modal/update-native-modal.component'
      ).then(m => m.UpdateNativeModalComponent),
    loadModule: () =>
      import(
        '@freelancer/ui/update-native-alert/modal/update-native-modal.module'
      ).then(m => m.UpdateNativeModalModule),
  },
  VideoModal: {
    loadComponent: () =>
      import('@freelancer/ui/video-modal/video-modal.component').then(
        m => m.VideoModalComponent,
      ),
    loadModule: () =>
      import('@freelancer/ui/video-modal/video-modal.module').then(
        m => m.VideoModalModule,
      ),
  },
  VideoRecordModal: {
    loadComponent: () =>
      import(
        '@freelancer/ui/video-record-modal/video-record-modal.component'
      ).then(m => m.VideoRecordModalComponent),
    loadModule: () =>
      import(
        '@freelancer/ui/video-record-modal/video-record-modal.module'
      ).then(m => m.VideoRecordModalModule),
  },
};
